// extracted by mini-css-extract-plugin
export default {"title":"hT3a1"};